import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'menuDishPipe'
})
export class MenuDishPipe implements PipeTransform {
    transform(dishes: any, term?: any): any {

        if( term === undefined) return dishes;
        if( term === null) return dishes;

        if(dishes != null){
            return dishes.filter(function(dish){
                if (dish.name_es != undefined)
                    if (dish.name_es.toLowerCase().includes(term.toLowerCase()))
                        return dish;
                    else if(dish.tags.toString() != undefined)
                        if(dish.tags.toString().toLowerCase().includes(term.toLowerCase()))
                            return dish;

            })
        }


    }
}


// WEBPACK FOOTER //
// ./src/pages/menu/menu-create/menu-create-dish-select/menu-partial-dishes-select/menu-dish-select-pipe.ts